<template>
    <div class="dashboard-footer-card">
        <flex-container align-items="center" gap="sm">
            <slot name="header" />
        </flex-container>
        <div>
            <text-decorator size="xs">
                <slot name="content" />
                <slot />
            </text-decorator>
        </div>
        <div class="dashboard-footer-card__actions">
            <slot name="actions" />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .dashboard-footer-card {
        background: var(--theme-colors-default--white);
        padding: size(md);
        border-radius: size(sm);
        display: grid;
        grid-template-rows: auto 1fr auto;
        gap: size(md);
        border: solid 1px var(--theme-colors-default--gray-300);

        &__actions {
            justify-self: end;
        }
    }
</style>
